// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3lAvWeL7YBOX0CtbzNx4Jl_0","dialog-contents":"_1oJG4J6vE84SjdXL9BOYmv_0","player":"_1ru7NljCG1ocr4mLUjsbso_0","active":"tWf9h1T32eIRhtty4DWRK_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d3d05d48","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.common/ui/players/selector.vue
// module id = 233
// module chunks = 0